import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { loaderInterceptor } from './app/core/interceptors/loader.interceptor';
import { apiPrefixInterceptor } from './app/core/interceptors/api-prefix.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { MessageService } from 'primeng/api';

const IndigoPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#eef2ff',
            100: '#e0e7ff',
            200: '#c7d2fe',
            300: '#a5b4fc',
            400: '#818cf8',
            500: '#6366f1',
            600: '#4f46e5',
            700: '#4338ca',
            800: '#3730a3',
            900: '#312e81',
            950: '#1e1b4b'
        }
    }
});

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withInterceptors([loaderInterceptor, apiPrefixInterceptor, errorInterceptor, authInterceptor]), withFetch()),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: IndigoPreset, options: { darkModeSelector: '.app-dark' } } }),
        MessageService
    ]
};
